import { CampaignLaunchProgressModel } from '@urbanx/agx.campaigns.client';
import './LaunchDetailsProgress.scss';
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { CircularProgressIndicator } from './CircularProgressIndicator';
import { renderProgress } from './LaunchDetailsProgress.helpers';

interface LaunchDetailsProgressProps {
  launchDetailsProgress?: CampaignLaunchProgressModel | undefined;
}

const LaunchDetailsProgress = ({ launchDetailsProgress }: LaunchDetailsProgressProps) => {
  const completedSteps = [
    launchDetailsProgress?.photosComplete,
    launchDetailsProgress?.floorplanComplete,
    launchDetailsProgress?.copywriteComplete,
    launchDetailsProgress?.videoComplete,
    launchDetailsProgress?.virtualTourComplete,
  ].filter(Boolean).length;

  return (
    <AgxSpacer
      direction="vertical"
      gap="lg"
      padding={{ top: 'xl', bottom: 'xl' }}
      contentJustification="center"
      contentAlignment="center"
      id="launchProgressPreparation"
      fill
    >
      <CircularProgressIndicator
        currentSteps={completedSteps}
        totalSteps={5}
        width={60}
        height={60}
      />
      <AgxTypography id="launch-preparation-in-progress" type="body" size="medium">
        Launch preparation in progress
      </AgxTypography>
      <AgxSpacer direction="vertical" fill id="launchProgressPreparationBody">
        {renderProgress('Photos', launchDetailsProgress?.photosComplete)}
        {renderProgress('Floor Plan', launchDetailsProgress?.floorplanComplete)}
        {renderProgress('Copywrite', launchDetailsProgress?.copywriteComplete)}
        {renderProgress('Video', launchDetailsProgress?.videoComplete)}
        {renderProgress('Virtual Tour', launchDetailsProgress?.virtualTourComplete)}
      </AgxSpacer>
    </AgxSpacer>
  );
};

export default LaunchDetailsProgress;
